module.exports = __webpack_public_path__ + "media/images/icons/filled/calculator-7b4d478ad5bf56c53b4691f3a4f2370b.svg";